<div
  class="flex h-full min-h-0 flex-col items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 px-6 py-12"
>
  <div
    class="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm"
  >
    <div
      class="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full"
      [class]="{
        'bg-emerald-100': estado() === 'conectado',
        'bg-amber-100': estado() === 'conectando',
        'bg-red-100': estado() === 'desconectado',
      }"
    >
      @if (estado() === 'conectado') {
        <svg
          class="h-7 w-7 text-emerald-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
        </svg>
      } @else if (estado() === 'conectando') {
        <svg
          class="h-7 w-7 animate-spin text-amber-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182"
          />
        </svg>
      } @else {
        <svg
          class="h-7 w-7 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      }
    </div>

    <h2 class="mb-2 text-xl font-semibold text-slate-800">WhatsApp</h2>

    @if (estado() === 'conectado') {
      <p class="mb-6 text-sm leading-relaxed text-slate-500">
        El telefono esta conectado correctamente.
      </p>
      <span
        class="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-3 py-1.5 text-xs font-medium text-emerald-700"
      >
        <span class="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
        Conectado
      </span>
    } @else if (qr()) {
      <p class="mb-6 text-sm leading-relaxed text-slate-500">
        Escanea este codigo QR con la aplicacion de WhatsApp en tu telefono para vincular este
        numero.
      </p>

      <div
        class="mx-auto mb-6 flex w-52 justify-center rounded-2xl border-2 border-purple-200 bg-white p-3 shadow-md"
      >
        <img
          class="h-48 w-48 rounded-lg"
          [src]="qr()?.startsWith('data:') ? qr() : 'data:image/png;base64,' + qr()"
          alt="WhatsApp QR Code"
        />
      </div>

      <p class="mb-4 text-[11px] leading-relaxed text-slate-400">
        Abre WhatsApp en tu telefono &rarr; Ajustes &rarr; Dispositivos vinculados &rarr; Vincular
        un dispositivo
      </p>

      <button
        type="button"
        class="w-full rounded-xl bg-purple-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-purple-700 active:bg-purple-800"
        (click)="reconectar()"
      >
        Volver a generar QR
      </button>
    } @else if (estado() === 'conectando') {
      <p class="mb-6 text-sm leading-relaxed text-slate-500">Solicitando nuevo codigo QR...</p>
      <div class="flex justify-center">
        <div
          class="h-10 w-10 animate-spin rounded-full border-4 border-purple-200 border-t-purple-600"
        ></div>
      </div>
    } @else {
      <p class="mb-6 text-sm leading-relaxed text-slate-500">
        El telefono no esta vinculado. Genera un codigo QR para conectarlo a WhatsApp.
      </p>
      <button
        type="button"
        class="w-full rounded-xl bg-purple-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-purple-700 active:bg-purple-800"
        (click)="reconectar()"
      >
        Conectar telefono
      </button>
    }
  </div>
</div>
